<template>
	<div id="header_app">
		<div class="layout-header">
			<!-- header date-->
			<div class="layout-header-date">
				<div class="layout-header-date-wrap">
					<div class="layout-header-date-text">
						<input class="text-horizontal date"
									 type="text"
									 :value="item.date"
									 @input="updateDate"
									 maxlength="16"/>
					</div>
				</div>
			</div>

			<!-- header logo brand-->
			<div class="layout-header-brand">
				<div class="layout-header-brand-wrap">
					<div class="layout-header-brand-logo">
						<div id="logoHeader">
							<div class="left">
								<span>新聞</span>
							</div>

							<div class="right">
								<span
										field-name="logo"
										ref="logo"
										contenteditable
										:class="logoClass"
										class="input-contenteditable logoText"
										@blur="cutString"
										@input="updateLogo"
										@keydown="submitText($event)"
										v-html="tmpLogo"/>

								<span class="placeholder" v-if="isShowPlaceholder">
									２<span class="sign">〜</span>４文字
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- header info-->
			<div class="layout-header-info">
				<div class="layout-header-info-wrap">
					<div class="layout-header-info-text">
						<input class="text-horizontal issuer"
									 type="text"
									 maxlength="10"
									 :value="item.issuer"
									 @input="updateIssuer"
									 placeholder="発行者を入力"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FormHeaderMixin from '../../mixins/formHeader.mixin'

	export default {
		name: 'FormHeader',

		mixins: [FormHeaderMixin]
	}
</script>

<style scoped lang="scss">
	#header_app {
		.layout-header {
			.layout-header-date,
			.layout-header-info {
				background: #F2F4F3 url('../../assets/img/bg-header.png') repeat-x;
			}
		}
	}
</style>